'use strict';

import raven from 'raven';
import LogRocket from 'logrocket';

class LoginService {
  /* @ngInject */
  constructor(
    SegaUser,
    EmployeesService,
    Client,
    $log,
    $rootScope,
    localStorageService,
    $window
  ) {
    Object.assign(this, {
      SegaUser,
      EmployeesService,
      Client,
      $log,
      $rootScope,
      localStorageService,
      $window
    });
  }

  login(opts = { rememberMe: false }, user = { email: '', password: '' }) {
    return this.SegaUser.login(opts, user).$promise;
  }

  logout() {
    return this.SegaUser.logout().$promise;
  }

  getCachedCurrent() {
    return this.SegaUser.getCachedCurrent();
  }

  getCurrent() {
    return this.SegaUser.getCurrent().$promise.then(user => {
      raven.setUserContext({
        email: user.email,
        id: user.id
      });

      LogRocket.identify(user.email);

      let isAdmin = !!user.roles.find(r => {
        return r.name === 'admin';
      });
      user.isAdmin = isAdmin;

      if (user.employeeId) {
        return this.EmployeesService.findById(user.employeeId).then(
          employee => {
            user.employee = employee;
            return user;
          }
        );
      } else {
        return user;
      }
      // eslint-disable-next-line no-unreachable
      return user;
    });
  }
}

export default LoginService;
